export default __webpack_public_path__ + "static/media/gb.6cc3727d.svg";